export default {
  'common.action': '操作',
  'common.operator': '操作人',
  'common.operationTime': '操作时间',
  'common.add': '新增',
  'common.edit': '编辑',
  'common.copy': '复制',
  'common.amend': '修改',
  'common.delete': '删除',
  'common.sureToDelete': '确定删除吗？',
  'common.confirm': '确定',
  'common.cancel': '取消',
  'common.back': '返回',
  // 修改密码
  'common.changePassword': '修改密码',
  'common.logout': '退出登录',
  'common.oldPassword': '原密码',
  'common.newPassword': '新密码',
  'common.confirmPassword': '确认密码',
  'common.pleaseEnterOldPassword': '请输入原密码',
  'common.pleaseEnterNewPassword': '请输入新密码',
  'common.pleaseEnterNewPasswordAgain': '请再次输入新密码',
  'common.passwordMin6': '密码至少6位',
  'common.passwordLength6to50': '密码长度为6-50位',
  'common.passwordFormat': '密码仅支持英文、数字、特殊字符',
  'common.passwordNotMatch': '两次输入的密码不一致',
  'common.changePasswordSuccess': '密码修改成功',
  'common.startTime.placeholder': '请选择开始时间',
  'common.endTime.placeholder': '请选择结束时间',
  'common.hint': '提示',
  'common.sort': '排序',
  'common.all': '全部',
  'common.type': '类型',
  'common.language': '语种',
  'common.operationFailed': '操作失败',
  'common.serialNumber': '序号',
  'common.account': '账号',
  'common.onlyUpload': '只能上传{types}文件',
  'common.remark': '备注',
  'common.pleaseEnter': '请输入',
  'common.operationSuccessful': '操作成功',
  'common.requestFail': '请求失败',
  'common.noResponse': '服务无响应，请重试',
  'common.requestError': '请求出错，请重试',
  'common.save': '保存',
  'common.uploadSuccessful': '上传成功',
  'common.uploadFailed': '上传失败',
  'common.requiredCannotEmpty': '必填不能为空',
  'common.allowEnter200Characters': '可以输入200个字符',
  'common.total': '总计',
  'common.startTime': '开始时间',
  'common.endTime': '结束时间',
  'common.dynamicPassword': '动态口令',
  'common.dynamicMustBe6': '请输入6位数字动态口令',
  'common.userDynamicPassword': '用户动态口令',
  'common.enterUserDynamicPassword': '请输入该用户扫码后的动态口令',
  'common.operatorDynamicPassword': '本人动态口令',
  'common.enterOperatorDynamicPassword': '请输入本人的动态口令',
  'common.view': '查看',
  'common.close': '关闭',
  'common.loading': '加载中...',
  'common.submit': '提交',
  'common.upload': '上传',
  'common.select.all': '全选',
  'common.detail': '详情',
  'common.yes': '是',
  'common.no': '否',
  'common.enable': '开启',
  'common.disable': '禁用',
  'common.qRCode': '二维码',
  'common.pass': '通过',
  'common.reject': '拒绝',
  'common.exportData': '确定导出数据吗?',
  'common.enterDynamicPassword': '请输入动态口令',
  'common.applyTime': '申请时间',
  'common.query': '查询',
  'common.verify': '审核',
  'common.operator/OperationTime': '操作人/操作时间',
  'common.confirm1': '确认',
  'common.people': '人',
  'common.count': '笔',
  'common.noAccessPermission': '当前页面无权限访问',
  'common.noPermission': '无查询权限，请联系管理员',
  'common.export': '导出',
  'common.maxExceedmin': '最大值不能小于最小值',
  'common.minExceedMax': '最小值不能大于最大值',
  'editor.bold': '加粗',
  'editor.italic': '斜体',
  'editor.underline': '下划线',
  'editor.strike': '删除线',
  'editor.blockquote': '引用',
  'editor.codeBlock': '代码块',
  'editor.link': '链接',
  'editor.image': '图片',
  'editor.video': '视频',
  'editor.orderedList': '有序列表',
  'editor.bulletList': '无序列表',
  'editor.decreaseIndent': '减少缩进',
  'editor.increaseIndent': '增加缩进',
  'editor.superscript': '上标',
  'editor.subscript': '下标',
  'editor.direction': '文本方向',
  'editor.table': '插入表格',
  'editor.font': '字体',
  'editor.header': '标题',
  'editor.fontSize': '字号',
  'editor.textColor': '文字颜色',
  'editor.backgroundColor': '背景颜色',
  'editor.align': '对齐',
  'common.minute': '分钟',
  'common.suggestSize': '建议尺寸为',
  'common.validateRange': '请输入1-99之间的整数',

  'common.phone': '手机号',
  'common.status': '状态',
};
